module.exports = __webpack_public_path__ + "img/back_2.150d257d.jpg";